/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DocumentGroup = {
    Counselor: 'Counselor',
    Client: 'Client',
    ClientSelf: 'ClientSelf',
    CaseNote: 'CaseNote',
    AssetInventoryDependants: 'AssetInventoryDependants',
    AssetInventoryBankStatement: 'AssetInventoryBankStatement',
    AssetInventoryIncome: 'AssetInventoryIncome',
    AssetInventoryExpenses: 'AssetInventoryExpenses',
    AssetInventoryOwnClaims: 'AssetInventoryOwnClaims',
    AssetInventoryDomesticRealEstate: 'AssetInventoryDomesticRealEstate',
    AssetInventoryForeignRealEstate: 'AssetInventoryForeignRealEstate',
    AssetInventoryBuildingSavingsContracts: 'AssetInventoryBuildingSavingsContracts',
    AssetInventorySavingsAccounts: 'AssetInventorySavingsAccounts',
    AssetInventoryLifeInsurances: 'AssetInventoryLifeInsurances',
    AssetInventoryPensionInsurances: 'AssetInventoryPensionInsurances',
    AssetInventorySecuritiesDepots: 'AssetInventorySecuritiesDepots',
    AssetInventoryCashAndBankAssets: 'AssetInventoryCashAndBankAssets',
    AssetInventoryVehicles: 'AssetInventoryVehicles',
    AssetInventoryBuildingsOnForeignLand: 'AssetInventoryBuildingsOnForeignLand',
    AssetInventoryTenancyRights: 'AssetInventoryTenancyRights',
    AssetInventoryCompanyShares: 'AssetInventoryCompanyShares',
    AssetInventoryCooperativeMemberships: 'AssetInventoryCooperativeMemberships',
    AssetInventoryOtherPropertyRights: 'AssetInventoryOtherPropertyRights',
    AssetInventoryDonations: 'AssetInventoryDonations'
} as const;
export type DocumentGroup = typeof DocumentGroup[keyof typeof DocumentGroup];


export function instanceOfDocumentGroup(value: any): boolean {
    for (const key in DocumentGroup) {
        if (Object.prototype.hasOwnProperty.call(DocumentGroup, key)) {
            if (DocumentGroup[key as keyof typeof DocumentGroup] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DocumentGroupFromJSON(json: any): DocumentGroup {
    return DocumentGroupFromJSONTyped(json, false);
}

export function DocumentGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentGroup {
    return json as DocumentGroup;
}

export function DocumentGroupToJSON(value?: DocumentGroup | null): any {
    return value as any;
}

export function DocumentGroupToJSONTyped(value: any, ignoreDiscriminator: boolean): DocumentGroup {
    return value as DocumentGroup;
}

